import React, { useState, useRef, useEffect } from "react"

export const CheckoutContext: any = React.createContext({})

export const CheckoutProvider = ({ children }): JSX.Element => {
  const [checkout, setCheckout] = useState(false)

  const prevCheckout = useRef(checkout)

  //save previous checkout in the prevCheckout ref
  useEffect(() => {
    if (!prevCheckout.current) {
      prevCheckout.current = checkout
    }
  }, [checkout])

  const values = {
    checkout,
    setCheckout,
  }

  return <CheckoutContext.Provider value={{ ...values }}>{children}</CheckoutContext.Provider>
}
